import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ClientEntitiesResolverErrorStatesEnum {
    GetCountriesFailed = ErrorStateScheduleEnum.PanelLeadsVerificationsClientsResolverStatesStartIndex,
    GetCountriesInvalidData,
    UserSearchFailed,
    GetRolesFailed,
    GetTradingPlatformsFailed
}
